import styled from "styled-components";

import { mobileBreakpoint, mobileHeightBreakpoint } from "../constants";
import { font } from "../styles";

export default styled.h4`
  font-family: ${font.body};
  font-size: 36px;
  @media screen and (max-width: ${mobileBreakpoint}),
    screen and (max-height: ${mobileHeightBreakpoint}) {
    font-size: 24px;
    letter-spacing: 0.8px;
  }
`;
